module.exports = __webpack_public_path__ + "static/img/10-人大附中实验小学1.9250c7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/10-人大附中实验小学1.png
// module id = nGF+
// module chunks = 0